var map = {
	"./components/code-history/code-history.module": [
		"./src/app/components/code-history/code-history.module.ts",
		"components-code-history-code-history-module"
	],
	"./components/customers/customers.module": [
		"./src/app/components/customers/customers.module.ts"
	],
	"./components/home/home.module": [
		"./src/app/components/home/home.module.ts"
	],
	"./components/logistic/logistic.module": [
		"./src/app/components/logistic/logistic.module.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;